module.exports = __webpack_public_path__ + "faa8d5c3015141f0dbb06c7b87fbc779.MP3";